import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from 'material-ui/CircularProgress';

const Loader = (props) => {
    const { size, thick, ...rest } = props;

    return (
        <CircularProgress
            size={ size }
            thickness={ thick }
            mode='indeterminate'
            { ...rest }
        />
    );
};

Loader.defaultProps = {
    size: 72,
    thick: 4,
};

Loader.propTypes = {
    size: PropTypes.number,
    thick: PropTypes.number,
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/loading/Loader.js